import React from 'react'

import { currentYear } from 'common/dateFormatters'

import Logo from 'assets/images/new-footer-logo.svg'

import { Col, Row } from '..'

import './FooterStyles.less'

type FooterProps = {
  className?: string
}

const Footer = ({ className }: FooterProps) => {
  return (
    <Row className={`pk_footer ${className}`}>
      <Col className="pk_fotter_left_section">
        <Row>
          <Col>
            <img src={Logo} alt="People Keep Logo" className="pk_footer_logo" />
          </Col>
          <Col className="pk_footer_copyright_info">
            <h6 className="pk_fotter_copyright">&copy; {currentYear()} PeopleKeep, Inc.</h6>
            <span className="pk_fotter_version">Version 2.0</span>
          </Col>
        </Row>
      </Col>
    </Row>
  )
}

export default Footer
